import { AllTextMaterialsQuery, useFetchAllTextMaterials } from '@@partner:graphql/query/textMaterial/textMaterial/allTextMaterials.gql'
import useFetchMorePagination from '@@partner:helpers/hooks/useFetchMorePagination'
import { usePartner } from '@@partner:helpers/hooks/auth'
import React, { useCallback } from 'react'
import { CheckPicker, Input, SelectPicker } from 'rsuite'
import { blockTypes } from './EditorItem'
import { renderLazyPickerMenu } from '@components/common/pickers'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'
import EntityLink, { EntityLinksList } from './EntityLink'


type TextMaterialBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function TextMaterialBlock ({
  block,
  onChange
}: TextMaterialBlockProps) {
  const { brandSlug } = usePartner()
  const [ nameFilter, setNameFilter ] = React.useState<string>('')
  
  const subtype = block.subtype

  const makeBasicVariables = (skip: boolean) => ({
    filter: {
      fields: [ 'name' ],
      op: nameFilter.length > 0 ? 'starts_with' : 'unwrap',
      value: [ nameFilter ]
    },
    pager: { 
      limit: 20
    },
    sort: {
      fieldName: 'created_at',
      direction: 0
    },
    skip
  })

  const { data, loading, error, fetchMore } =  useFetchAllTextMaterials(makeBasicVariables(subtype !== 'group'))
  
  const updaterFunction = useCallback((cached: AllTextMaterialsQuery, fetched: AllTextMaterialsQuery) => {
    const prev = cached?.allTextMaterials?.edges ?? []
    const curr = fetched?.allTextMaterials?.edges ?? []

    return {
      hasMore: curr.length > 0,
      result: {
        allBanners: {
          ...fetched.allTextMaterials,
          edges: [ ...prev, ...curr ]
        }
      }
    }
  }, [])

  const { hasMore, fetchNextPage } = useFetchMorePagination({
    loading,
    page: data?.allTextMaterials.pageInfo.page ?? 1,
    pageVariable: 'pager',
    usePager: true,
    fetchMore,
    updaterFunction,
  })

  const textMaterials = data?.allTextMaterials?.edges.map(edge => ({
    label: edge.name,
    value: edge.id,
  })) ?? []

  const onItemsRendered = (props: any) => {
    if (props.visibleStopIndex >= textMaterials.length - 1 && hasMore) {
      fetchNextPage()
    }
  }

  return (
    <div>
      <h4>Выберите источник материалов:</h4>
      <SelectPicker
        data={blockTypes.find(bt => bt.type === 'textMaterials')?.subtypes ?? []}
        value={block.subtype}
        onSelect={(value) => {
          if (onChange && value) {
            onChange({
              ...block,
              subtype: value,
            })
          }
        }}
        placeholder="Выберите подтип блока"
        style={{ marginBottom: 16 }}
      />
      { block.subtype === 'single' ? (
        <div>
          <h4>Выберите материал:</h4>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SelectPicker
              data={textMaterials}
              value={block.payload?.id}
              loading={loading && !data}
              onSelect={(value) => {
                if (onChange && value) {
                  onChange({
                    ...block,
                    payload: {
                      id: value,
                    }
                  })
                }
              }}
              onSearch={setNameFilter}
              renderMenu={renderLazyPickerMenu(loading, data)}
              placeholder="Выберите материал"
              listProps={{
                onItemsRendered
              }}
              style={{ flex: 1 }}
            />
            <EntityLink
              entityId={block.payload?.id}
              entityType="textMaterial"
              brandSlug={brandSlug}
              tooltip="Перейти к материалу"
            />
          </div>
        </div>
      ) : block.subtype === 'block' ? (
        <div>
          <div style={{ marginBottom: 10 }}>
            <div>Название</div>
            <Input
              value={block.payload?.name || ''}
              onChange={(value) =>
                onChange({
                  ...block,
                  payload: {
                    ...block.payload,
                    name: value
                  }
                })
              }
              placeholder="Введите название"
            />
          </div>
          <h4>Выберите материалы:</h4>
          <CheckPicker
            data={textMaterials}
            value={block.payload?.ids}
            loading={loading && !data}
            onSelect={(value) => {
              if (onChange && value) {
                onChange({
                  ...block,
                  payload: {
                    ...block.payload,
                    ids: value,
                  }
                })
              }
            }}
            onSearch={setNameFilter}
            renderMenu={renderLazyPickerMenu(loading, data)}
            placeholder="Выберите материалы"
            listProps={{
              onItemsRendered
            }}
          />
          <EntityLinksList
            entityIds={block.payload?.ids}
            entityType="textMaterial"
            brandSlug={brandSlug}
            labels={textMaterials.reduce((acc, m) => ({ ...acc, [m.value]: m.label }), {})}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  )
}